const CASHAPPPAY_SANDBOX_SDK = 'https://sandbox.kit.cash.app/v1/pay.js';
const CASHAPPPAY_PROD_SDK = 'https://kit.cash.app/v1/pay.js';

export { CASHAPPPAY_SANDBOX_SDK, CASHAPPPAY_PROD_SDK };
